import { COUNTRIES_META } from 'constants/cart';


export const OmsAddressTransformer = (data: OmsAddressType) => ({
        street: data.addressLine1,
        addressLine2: data.addressLine2,
        billingAddressLine1: data.billingAddressLine1,
        billingAddressLine2: data.billingAddressLine2,
        billingCity: data.billingCity,
        billingEmail: data.billingEmail,
        billingName: data.billingName,
        billingPhoneNo: data.billingPhoneNo,
        billingPincode: data.billingPincode,
        billingState: data.billingState,
        city: data.city,
        countryCode: data.countryCode,
        email: data.email,
        isSame: data.isSame,
        isd: data.isd,
        name: data.name,
        phone: data.phoneNo,
        pincode: data.pincode,
        state: data.state,
        userId: data.userId,
        dialCode: data.countryCode ? COUNTRIES_META[data.countryCode].DIAL_CODE : data.isdCode,
        country: data.countryCode ? COUNTRIES_META[data.countryCode].NAME : 'India',
});
